// extracted by mini-css-extract-plugin
module.exports = {"articles":"Section2Cards_articles__To9Xi","article":"Section2Cards_article__oOIpC"};